"use client";

import React from "react";
import { Droplets, ShieldCheck, Wind, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  icon: ShieldCheck,
  text: "01. Comprehensive Inspection: Every vehicle undergoes a rigorous multi-point diagnostic check by our master mechanics."
}, {
  icon: Droplets,
  text: "02. Transparent Consultation: We walk you through the findings with clear explanations and upfront pricing before any work begins."
}, {
  icon: Wind,
  text: "03. Precision Repair: Using state-of-the-art tools and century-old expertise to restore your vehicle to factory standards."
}, {
  icon: Sparkles,
  text: "Certified Excellence: Our 3-Step Quality Guarantee ensures your safety and satisfaction on every Albany road."
}];
export default function ServiceDetails() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="234959" id="the-dotts-standard" className="bg-background text-foreground py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative rounded-md shadow-xl overflow-hidden group border border-border">
            <div className="absolute inset-0 bg-primary/5 group-hover:bg-transparent transition-colors duration-500 z-10 pointer-events-none"></div>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/mechanic_engine_diagnostic.png" alt="Certified mechanic performing precision engine diagnostic" className="w-full h-auto object-cover aspect-[4/3] transform group-hover:scale-105 transition-transform duration-700 ease-in-out grayscale-[0.2] contrast-125" loading="lazy" />
          </div>

          {}
          <div className="flex flex-col justify-center">
            <h2 className="text-3xl md:text-5xl font-bold font-default text-primary mb-8 leading-tight tracking-tight uppercase">
              The Dott's Standard of Care
            </h2>
            
            <ul className="space-y-6">
              {benefits.map((benefit, i) => {
              const Icon = benefit.icon;
              return <li data-index={i} key={i} className="flex items-start gap-4">
                    <div className="flex-shrink-0 mt-1">
                      <Icon className="w-6 h-6 text-primary stroke-[1.5]" aria-hidden="true" />
                    </div>
                    <p className="text-foreground/80 font-default text-lg leading-relaxed">
                      {benefit.text}
                    </p>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}